import getStatusEventIcon from './icon-status-event.js';
import openPostWindow from  './open-window-with-post.js';
import getStatusObjectIcon from  './icon-status-object.js';
import getLocalDateTime from  './local-time.js';
import getIconSensor from './getIconSensor.js';
import translate from './translate.js';
import moment from 'moment';
import getIgnitionIcon from './icon-ignition.js';

//let _instanceFmTools;

exports.getStatusEventIcon = getStatusEventIcon;
exports.openPostWindow = openPostWindow;
exports.getStatusObjectIcon = getStatusObjectIcon;
exports.getLocalDateTime = getLocalDateTime;
exports.getIconSensor = getIconSensor;
exports.timeZoneOffsetMinutes = (new Date()).getTimezoneOffset();
exports.translate = translate;
exports.getIgnitionIcon = getIgnitionIcon;

export default  class fmtools {
    constructor(timeZoneOffsetMinutes = (new Date()).getTimezoneOffset()) {
     
        //if(_instanceFmTools) return _instanceFmTools;

        this.timeZoneOffsetMinutes = timeZoneOffsetMinutes;
        if (window.location.href.includes('report-designer')) {
            let url = `${window.location.origin}/api/Api.svc/getusersettingsnew`;
            fetch(url)
                .then(response => response.json())
                .then(data => this.timeZoneOffsetMinutes = data.TimeZone * -60);
        }

        this.getStatusEventIcon = getStatusEventIcon;
        this.getStatusObjectIcon = getStatusObjectIcon;
        this.getLocalDateTime = getLocalDateTime;
        this.openPostWindow = openPostWindow;
        this.getIconSensor = getIconSensor;
        this.translate = translate;
        this.getIgnitionIcon = getIgnitionIcon;

        this.time = {
            getCurrentDayStart: () => moment().startOf('day').toDate(),
            getCurrentDayEnd: () => moment().endOf('day').toDate(),
            getLastDayStart: () => moment().subtract(1, 'day').startOf('day').toDate(),
            getLastDayEnd: () => moment().subtract(1, 'day').endOf('day').toDate(),
            getCurrentWeekStart: () => moment().startOf('isoWeek').toDate(),
            getCurrentWeekEnd: () => moment().endOf('isoWeek').toDate(),
            getLastWeekStart: () => moment().subtract(1, 'week').startOf('isoWeek').toDate(),
            getLastWeekEnd: () => moment().subtract(1, 'week').endOf('isoWeek').toDate(),
            getCurrentMonthStart: () => moment().startOf('month').toDate(),
            getCurrentMonthEnd: () => moment().endOf('month').toDate(),
            getLastMonthStart: () => moment().subtract(1, 'month').startOf('month').toDate(),
            getLastMonthEnd: () => moment().subtract(1, 'month').endOf('month').toDate(),
        };
       // _instanceFmTools = this;
    }
}

window.fmtools = new fmtools();



// WEBPACK FOOTER //
// ./app/fm-tools.js